import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ert-footer-dialog',
  templateUrl: './footer-dialog.component.html',
  styleUrls: ['./footer-dialog.component.scss']
})
export class FooterDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
